const ISO_CODE = /^[A-Z]{2}$/i;
const MIN_PHONE_DIGITS = 4;

const extractPhone = (value: string) => {
  const digits = value.replace(/\D/g, "");
  if (digits.length < MIN_PHONE_DIGITS) {
    return "";
  }
  return value.startsWith("+") ? `+${digits}` : digits;
};

export const resolvePhoneColumns = (columns: (string | undefined)[]) => {
  let phone = "";
  let phone_country = "";

  for (const col of columns) {
    const trimmed = (col ?? "").trim();
    if (!trimmed) {
      continue;
    }

    if (!phone_country && ISO_CODE.test(trimmed)) {
      phone_country = trimmed.toUpperCase();
      continue;
    }

    if (!phone) {
      const candidate = extractPhone(trimmed);
      if (candidate) {
        phone = candidate;
      }
    }
  }

  return { phone, phone_country };
};
